import llogo from '../../assets/images/llogo.png'
import playstore from '../../assets/icons/playstore.png'
import appstore from '../../assets/icons/appstore.png'
import React from 'react'
import {NavDiv} from './NavbarStyle'


import {Link} from 'react-router-dom';




function Navbar() {
    return (
        <NavDiv>
            <nav className="navbar navbar-expand-md navbar-dark fixed-top">
                <div className="container ">

              <Link className="navbar-brand">
              <img src={llogo} />
              </Link>

            
              
              <button className="navbar-toggler bg-info" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                <span className="navbar-toggler-icon"></span>
              </button>
            

              
              <div className="collapse navbar-collapse pt-2" id="collapsibleNavbar">
              
                <ul className="navbar-nav ml-auto">
                  <Link to='/' className="nav-link nav-item nv">        
                     <p>Home</p>
                  </Link>

                  <Link to='/' className="nav-link nav-item nv">        
                     <p>About</p>
                  </Link>

                  <Link to='/contact' className="nav-link nav-item nv">        
                     <p>Contact Us</p>
                  </Link>

                  <Link to='/blog' className="nav-link nav-item nv">        
                     <p>Blog</p>
                  </Link>

                  <Link to='/' className="nav-link nav-item nv">        
                     <p>Faqs</p>
                  </Link>
                   
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle nav-item dropdown" href="#" id="navbardrop" data-toggle="dropdown">
                    Create Account
                  </a>
                  <div className="dropdown-menu">
                    <Link to="/customer/register">
                    <p className="dropdown-item">Patient</p>
                    </Link>
                    <Link>
                    <p className="dropdown-item">Pharmacy</p>
                    </Link>
                    <Link>
                    <p className="dropdown-item">Doctor</p>
                    </Link>
                    <Link>
                    <p className="dropdown-item">Hospital</p>
                    </Link>
                  </div>
                </li>

                <div className="store-div">   
                  <li className="nav-item">
                      <a className="nav-link" href="#"><img src={playstore} /></a>
                    </li>

                  <li className="nav-item">
                      <a className="nav-link" href="#"><img src={appstore} /></a>
                  </li>
              </div>

                </ul>
              </div>
                </div>
            </nav>
            
        </NavDiv>
    )
}

export default Navbar
